import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/MicrosoftOfficePowrpointColor.tsx
const MicrosoftOfficePowrpointColorIcon = ZepIcon((props) => /* @__PURE__ */ jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M21.824 12c0-5.247-4.294-9.5-9.592-9.5C6.934 2.5 2.64 6.753 2.64 12s4.294 9.5 9.592 9.5c5.298 0 9.592-4.253 9.592-9.5Z",
			fill: "url(#paint0_linear_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.824 12c0-5.247-4.294-9.5-9.592-9.5C6.934 2.5 2.64 6.753 2.64 12s4.294 9.5 9.592 9.5c5.298 0 9.592-4.253 9.592-9.5Z",
			fill: "url(#paint1_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.824 12c0-5.247-4.294-9.5-9.592-9.5C6.934 2.5 2.64 6.753 2.64 12s4.294 9.5 9.592 9.5c5.298 0 9.592-4.253 9.592-9.5Z",
			fill: "url(#paint2_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.233 2.5c5.298 0 9.593 4.253 9.593 9.5 0 1.745-.477 3.38-1.306 4.786l.156-.342c.95-2.088-.594-4.45-2.906-4.448l-3.817.003a1.71 1.71 0 0 1-1.72-1.701V6.51c0-2.29-2.388-3.816-4.495-2.873l-.307.138A9.62 9.62 0 0 1 12.233 2.5Z",
			fill: "url(#paint3_linear_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.233 2.5c5.298 0 9.593 4.253 9.593 9.5 0 1.745-.477 3.38-1.306 4.786l.156-.342c.95-2.088-.594-4.45-2.906-4.448l-3.817.003a1.71 1.71 0 0 1-1.72-1.701V6.51c0-2.29-2.388-3.816-4.495-2.873l-.307.138A9.62 9.62 0 0 1 12.233 2.5Z",
			fill: "url(#paint4_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.233 2.5c5.298 0 9.593 4.253 9.593 9.5 0 1.745-.477 3.38-1.306 4.786l.156-.342c.95-2.088-.594-4.45-2.906-4.448l-3.817.003a1.71 1.71 0 0 1-1.72-1.701V6.51c0-2.29-2.388-3.816-4.495-2.873l-.307.138A9.62 9.62 0 0 1 12.233 2.5Z",
			fill: "url(#paint5_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.233 2.5c5.298 0 9.593 4.253 9.593 9.5 0 1.745-.477 3.38-1.306 4.786l.156-.342c.95-2.088-.594-4.45-2.906-4.448l-3.817.003a1.71 1.71 0 0 1-1.72-1.701V6.51c0-2.29-2.388-3.816-4.495-2.873l-.307.138A9.62 9.62 0 0 1 12.233 2.5Z",
			fill: "url(#paint6_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M12.233 2.5c5.298 0 9.593 4.253 9.593 9.5 0 1.745-.477 3.38-1.306 4.786l.156-.342c.95-2.088-.594-4.45-2.906-4.448l-3.817.003a1.71 1.71 0 0 1-1.72-1.701V6.51c0-2.29-2.388-3.816-4.495-2.873l-.307.138A9.62 9.62 0 0 1 12.233 2.5Z",
			fill: "url(#paint7_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M3.663 11.493h4.86c.919 0 1.663.737 1.663 1.647v4.813c0 .91-.744 1.647-1.663 1.647h-4.86A1.655 1.655 0 0 1 2 17.953V13.14c0-.91.744-1.647 1.663-1.647Z",
			fill: "url(#paint8_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M3.663 11.493h4.86c.919 0 1.663.737 1.663 1.647v4.813c0 .91-.744 1.647-1.663 1.647h-4.86A1.655 1.655 0 0 1 2 17.953V13.14c0-.91.744-1.647 1.663-1.647Z",
			fill: "url(#paint9_radial_869_1256)"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M5.694 16.354v1.509H4.64V13.23h1.627c.582 0 1.026.126 1.33.378.307.252.46.626.46 1.121 0 .51-.172.91-.515 1.196-.342.286-.8.43-1.376.43h-.473Zm0-2.322v1.521h.44c.26 0 .462-.068.603-.204.141-.135.212-.33.212-.584 0-.235-.07-.416-.209-.543-.137-.127-.333-.19-.59-.19h-.456Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ jsxs("defs", { children: [
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint1_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(-13.6195 13.4871 -22.9234 -22.7006 16.023 8.013)",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ jsx("stop", {
						offset: .152,
						stopColor: "#AA1D2D"
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: .381,
						stopColor: "#D12B18",
						stopOpacity: .439
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: .602,
						stopColor: "#FF3C00",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint2_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(16.5094 -7.7222 14.1272 29.6183 -.71 19.722)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .407,
					stopColor: "#FF66FB",
					stopOpacity: .502
				}), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#EA3D01",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint4_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(12.1381 2.51877 -2.42483 11.4593 10.621 13.136)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .786,
					stopColor: "#FFA05C",
					stopOpacity: 0
				}), /* @__PURE__ */ jsx("stop", {
					offset: .905,
					stopColor: "#FFCE84"
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint5_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(10.4788 -6.78987 6.55698 9.92357 12.567 11.857)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .295,
					stopColor: "#FF99E9",
					stopOpacity: .8
				}), /* @__PURE__ */ jsx("stop", {
					offset: .728,
					stopColor: "#FF99E9",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint6_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(8.771 -9.94401 9.1708 7.93248 11.16 13.308)",
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ jsx("stop", { stopColor: "#FD6EF9" }),
					/* @__PURE__ */ jsx("stop", {
						offset: .637,
						stopColor: "#F94"
					}),
					/* @__PURE__ */ jsx("stop", {
						offset: .852,
						stopColor: "#FCC479"
					})
				]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint7_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(-.99074 6.64812 -15.1724 -2.21731 10.288 3.756)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .144,
					stopColor: "#FF8D13"
				}), /* @__PURE__ */ jsx("stop", {
					offset: .537,
					stopColor: "#FF7F29",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint8_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "scale(11.5771 11.46455) rotate(45 -1.124 .71)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#F8193E" }), /* @__PURE__ */ jsx("stop", {
					offset: .939,
					stopColor: "#920616"
				})]
			}),
			/* @__PURE__ */ jsxs("radialGradient", {
				id: "paint9_radial_869_1256",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "matrix(0 5.67467 -6.52342 0 6.092 16.357)",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .576,
					stopColor: "#FFB055",
					stopOpacity: 0
				}), /* @__PURE__ */ jsx("stop", {
					offset: .974,
					stopColor: "#FFF2BE",
					stopOpacity: .302
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint0_linear_869_1256",
				x1: 11.258,
				y1: 1.895,
				x2: -.386,
				y2: 13.144,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .058,
					stopColor: "#FF7F48"
				}), /* @__PURE__ */ jsx("stop", {
					offset: 1,
					stopColor: "#E5495B"
				})]
			}),
			/* @__PURE__ */ jsxs("linearGradient", {
				id: "paint3_linear_869_1256",
				x1: 14.049,
				y1: 14.114,
				x2: 24.302,
				y2: 6.44,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", {
					offset: .311,
					stopColor: "#FF6E30"
				}), /* @__PURE__ */ jsx("stop", {
					offset: .635,
					stopColor: "#FFA05C"
				})]
			})
		] })
	]
}));
//#endregion
export { MicrosoftOfficePowrpointColorIcon };
